import * as React from 'react';
import * as _ from 'underscore';

import { CommonStyles } from '../../common/react/CommonStyles';
import { DeprecatedReactActionsMenu } from '../../common/react/components/ActionsMenu';

const Colors = CommonStyles.Colors,
      Sizes = CommonStyles.Sizes;

const Width = Sizes.NormalIconSize + Sizes.IconHoverExpansion,
      Height = Width;

export const ButtonStyle: React.CSSProperties = {
  boxSizing: 'border-box',
  width: Width,
  height: Height,
  verticalAlign: 'baseline',
};

export const ButtonHoverStyle: React.CSSProperties = {
  backgroundColor: Colors.TextButtonHoverFillColor,
};

export const MenuPanelStyle: React.CSSProperties = {
  top: Height
};

/**
 * The DeprecatedReactPlacePageActionsMenu is a wrapper around the ActionsMenu component that includes the proper
 * styling for the menu to be in the place page header, next to the place title.
 *
 * This is deprecated because, even though it's written in React, it doesn't use Shared Widgets.
 */
export function DeprecatedReactPlacePageActionsMenu<S, D>(props: DeprecatedReactPlacePageActionsMenu.Props<S, D>) {
  return DeprecatedReactActionsMenu.element(_.extend({
    buttonStyle: ButtonStyle,
    buttonHoverStyle: ButtonHoverStyle,
    menuPanelStyle: MenuPanelStyle,
  }, props));
}

export namespace DeprecatedReactPlacePageActionsMenu {
  export interface Props<S, D> extends DeprecatedReactActionsMenu.Props<S, D> {}
}
